import { PicklistDataItem } from "../../../Engine/Core/Picklists/PicklistTypes";
import { isNotNullOrEmpty, isNotNullOrUndefined, reject } from "../../../../../Common/TypingUtils";

import { TaxRebateColumnNamesMap, TaxRebateItem } from "./TaxRebate";
import { TaxRebateValueInfo } from "./TaxRebateValueSplit";

export const lawValueRegexp = /.*/;

export function taxRebateItemMatchTo(item: TaxRebateItem, value: string): boolean {
    return item.code.includes(value) || item.name.toLowerCase().includes(value.toLowerCase());
}

const defaultMap: TaxRebateColumnNamesMap = { code: "code", name: "name", lawReferenceRequired: undefined };
export function taxRebateItemFromDigestResponse(
    picklistDataItems: PicklistDataItem[],
    columnNamesMap: TaxRebateColumnNamesMap = defaultMap,
    codesWithLawReference: string[] = []
): TaxRebateItem[] {
    return picklistDataItems.map(digestItem => {
        const code = digestItem[columnNamesMap.code]?.toString() ?? reject();
        const lawReferenceRequiredValue = columnNamesMap.lawReferenceRequired
            ? digestItem[columnNamesMap.lawReferenceRequired]?.toString()
            : false;
        const lawReferenceRequired =
            lawReferenceRequiredValue?.toString() === "1" ||
            lawReferenceRequiredValue === "true" ||
            codesWithLawReference.includes(code);
        return {
            code: code ?? reject(),
            name: digestItem[columnNamesMap.name]?.toString() ?? reject(),
            lawReferenceRequired: lawReferenceRequired,
        };
    });
}

export const buildValue = (
    code: string,
    lawValues: { law1: undefined | string; law2: undefined | string; law3: undefined | string },
    lawPattern: {
        law1Length: number;
        law2Length: number;
        law3Length: number;
        law1Delimiter: string;
        law2Delimiter: string;
        law3Delimiter: string;
        codeLength: number;
    }
): string => {
    const { law1, law2, law3 } = lawValues;
    const { law1Length, law2Length, law3Length, law1Delimiter, law2Delimiter, law3Delimiter, codeLength } = lawPattern;

    const codeValue = codeLength > 0 ? (code ?? "").slice(0, codeLength).padStart(codeLength, "0") : code;

    if (law1 == undefined && law2 == undefined && law3 == undefined) {
        return `${codeValue}${law1Delimiter}`;
    }

    let laws = undefined;
    if (isNotNullOrEmpty(law3)) {
        laws = `${law3Delimiter}${law3Length > 0 ? law3.padStart(law3Length, "0") : law3}`;
    }
    if (isNotNullOrUndefined(laws) || isNotNullOrEmpty(law2)) {
        const law2Safe = law2 ?? "";
        laws = `${law2Delimiter}${law2Length > 0 ? law2Safe.padStart(law2Length, "0") : law2Safe}` + (laws ?? "");
    }
    if (isNotNullOrUndefined(laws) || isNotNullOrEmpty(law1)) {
        const law1Safe = law1 ?? "";
        laws = `${law1Delimiter}${law1Length > 0 ? law1Safe.padStart(law1Length, "0") : law1Safe}` + (laws ?? "");
    }
    if (isNotNullOrUndefined(laws)) {
        return `${codeValue}${laws}`;
    }
    return codeValue;
};

export const splitTaxRebateValueNoHasLaws = (value?: TaxRebateValueInfo): boolean =>
    value?.law1?.value == undefined && value?.law2?.value == undefined && value?.law3?.value == undefined;
